<div class="container">
  <app-info-banner />
</div>

<header class="main-header">
  <div class="container">
    <app-logo />

    <div class="actions">
      <app-header-button routeLink="/service" icon="CircleQuestionMark">{{ "common.action.contact_support" | translate }}</app-header-button>
      <app-header-button routeLink="/account" icon="UserRound">{{ "common.action.my_account" | translate }}</app-header-button>
      <app-button-badge [count]="favoriteProducts().length">
        <app-header-button routeLink="/favorite-products" icon="Heart">{{ "common.action.favorites" | translate }}</app-header-button>
      </app-button-badge>
      <app-button-badge [count]="cartCount$ | async">
        <app-header-button icon="ShoppingCart" routeLink="/cart">{{ "common.action.cart" | translate }}</app-header-button>
      </app-button-badge>
    </div>
  </div>
</header>
